import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { supportedLanguages, type SupportedLanguage } from '../i18n';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const currentLanguage = (supportedLanguages.includes(i18n.language as SupportedLanguage)
    ? i18n.language
    : 'en') as SupportedLanguage;
  const languageNames: Record<SupportedLanguage, string> = { en: 'English', fr: 'Français', zh: '中文' };

  return (
    <label className="flex items-center gap-1.5 text-gray-600">
      <Globe size={20} className="text-gray-600" />
      <span className="sr-only">Language</span>
      <select
        aria-label="Language"
        className="cursor-pointer bg-transparent text-sm text-gray-600 outline-none"
        onChange={(event) => i18n.changeLanguage(event.target.value)}
        value={currentLanguage}
      >
        {supportedLanguages.map((language) => (
          <option key={language} value={language}>
            {languageNames[language]}
          </option>
        ))}
      </select>
    </label>
  );
};

export default LanguageSwitcher;
